import { INIT, UPDATE_SUCCESS, UPDATE_FAIL } from "../actions/evaluationTerm";

const initialState = { row: [] };

const evaluationTerm = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INIT:
      return {
        ...state,
        row: payload.row
      };
    case UPDATE_SUCCESS:
      return {
        ...state,
        params: payload.params
      };
    case UPDATE_FAIL:
      return {
        ...state,
        message: payload.message,
        error: payload.error
      };

    default:
      return {
        ...state
      };
  }
};

export default evaluationTerm;
